import { all } from 'redux-saga/effects';
import appSaga from './appSaga';
import authSagas from 'modules/auth/saga';
import employeeSagas from 'modules/employee/saga';
import vehicleSagas from 'modules/vehicle/saga';
import routeSagas from 'modules/route/saga';
import reportSagas from 'modules/report/saga';
import companySagas from 'modules/company/saga';
import permissionSagas from 'modules/permission/saga';
import monthlyTicketSagas from 'modules/monthly-ticket/saga';
import customerSagas from 'modules/customer/saga';
import governanceSagas from 'modules/governance/saga';
import trackingSagas from 'modules/tracking/saga';
import notifySaga from 'modules/notification/sagas/notificationSaga';
import transportOrdersSaga from 'modules/transport-orders/saga';
import executiveSagas from 'modules/executive/saga';
import promotionSaga from 'modules/promotion/saga';
import businessPlanSaga from 'modules/business-plan/saga';

export default function* rootSaga() {
    yield all([
        appSaga(),
        notifySaga(),
        ...authSagas.map((saga) => saga()),
        ...employeeSagas.map((saga) => saga()),
        ...vehicleSagas.map((saga) => saga()),
        ...routeSagas.map((saga) => saga()),
        ...reportSagas.map((saga) => saga()),
        ...companySagas.map((saga) => saga()),
        ...permissionSagas.map((saga) => saga()),
        ...monthlyTicketSagas.map((saga) => saga()),
        ...customerSagas.map((saga) => saga()),
        ...governanceSagas.map((saga) => saga()),
        ...trackingSagas.map((saga) => saga()),
        ...transportOrdersSaga.map((saga) => saga()),
        ...executiveSagas.map((saga) => saga()),
        ...promotionSaga.map((saga) => saga()),
        ...businessPlanSaga.map((saga) => saga()),
    ]);
}
